import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import auth from "./reducers/auth";
import dashboard from "./reducers/dashboard";
import matchDetail from "./reducers/matchDetail";
import userManagement from "./reducers/userManagement";
import { authApi } from "../services/auth/authApi";
import { sportsApi } from "../services/sports/sportsApi";
import { ledgerApi } from "../services/ledger/ledgerApi";
import { exposureApi } from "../services/exposure/exposureApi";
import { casinoApi } from "../services/casino/casinoApi";
import { userApi } from "../services/user/userApi";
import { matkaApi } from "../services/matka/matkaApi";
import { ludoApi } from "../services/ludo/ludoApi";
import diceApi from "../services/dice/diceServices";
import aviatorApi from "../services/aviator/aviatorApi";
import rouletteApi from "../services/roulette/rouletteApi";

const rootReducer = combineReducers({
  auth: auth,
  dashboard: dashboard,
  matchDetail: matchDetail,
  userManagement: userManagement,
  [authApi.reducerPath]: authApi.reducer,
  [sportsApi.reducerPath]: sportsApi.reducer,
  [ledgerApi.reducerPath]: ledgerApi.reducer,
  [exposureApi.reducerPath]: exposureApi.reducer,
  [casinoApi.reducerPath]: casinoApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [matkaApi.reducerPath]: matkaApi.reducer,
  [ludoApi.reducerPath]: ludoApi.reducer,
  [diceApi.reducerPath]: diceApi.reducer,
  [aviatorApi.reducerPath]: aviatorApi.reducer,
  [rouletteApi.reducerPath]: rouletteApi.reducer,
});

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: function(getDefaultMiddleware) {
    return getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(authApi.middleware, sportsApi.middleware, ledgerApi.middleware, exposureApi.middleware, casinoApi.middleware, userApi.middleware, matkaApi.middleware, ludoApi.middleware, diceApi.middleware, aviatorApi.middleware, rouletteApi.middleware);
  },
  devTools: import.meta.env.DEV,
});

export default store;
export const persistor = persistStore(store);
